module.exports = __webpack_public_path__ + "static/media/Logo-Dark.bfb65a55.svg";